var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSortIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.22969 7.48009C2.37599 7.3335 2.61343 7.33327 2.76002 7.47957L5.27002 9.98457C5.41661 10.1309 5.41685 10.3683 5.27055 10.5149C5.12425 10.6615 4.88681 10.6617 4.74022 10.5154L2.23022 8.01042C2.08362 7.86412 2.08339 7.62669 2.22969 7.48009Z",
    fill: "#A3A1AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00488 1.375C5.21199 1.375 5.37988 1.54289 5.37988 1.75V10.25C5.37988 10.4571 5.21199 10.625 5.00488 10.625C4.79778 10.625 4.62988 10.4571 4.62988 10.25V1.75C4.62988 1.54289 4.79778 1.375 5.00488 1.375Z",
    fill: "#A3A1AA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.72969 1.4851C7.87599 1.33851 8.11343 1.33827 8.26002 1.48457L10.77 3.98957C10.9166 4.13587 10.9168 4.37331 10.7705 4.5199C10.6242 4.66649 10.3868 4.66673 10.2402 4.52043L7.73022 2.01543C7.58362 1.86913 7.58339 1.63169 7.72969 1.4851Z",
    fill: "#A3A1AA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99512 1.375C8.20222 1.375 8.37012 1.54289 8.37012 1.75V10.25C8.37012 10.4571 8.20222 10.625 7.99512 10.625C7.78801 10.625 7.62012 10.4571 7.62012 10.25V1.75C7.62012 1.54289 7.78801 1.375 7.99512 1.375Z",
    fill: "#A3A1AA"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIcon);
export default __webpack_public_path__ + "static/media/sortIcon.907ae112.svg";
export { ForwardRef as ReactComponent };